"use strict";

import angular from "angular";
import { Events } from "../../presentation/services/Events/Events";

export class UserProfileSidenavService {
    constructor() {
        this.elementContext = {};
        this.opened = false;
        this.user = {};
        this.accounting = {};

        this.Events = new Events();
    }

    setElementContext(elementContext) {
        this.elementContext = elementContext;
    }

    open() {
        this.Events.send("menu.perfil.usuario");
        this.elementContext.addClass("sidenav-opened");
        this.elementContext.removeClass("sidenav-closed");

        this.opened = true;
    }

    close() {
        this.elementContext.addClass("sidenav-closed");
        this.elementContext.removeClass("sidenav-opened");

        this.opened = false;
    }

    setUser(user) {
        this.user = user;
        this.user.profile.initials = this.getInitials(
            this.user.profile.nickname || this.user.profile.name
        );
    }

    setAccounting(accounting) {
        this.accounting = accounting;
    }

    getInitials(name) {
        return !name
            ? ""
            : name
                  .replace(/[^\w\s]/gi, "")
                  .split(" ")
                  .map((word, index, arr) =>
                      index == 0 || (arr.length > 1 && index == arr.length - 1)
                          ? word.charAt(0)
                          : ""
                  )
                  .join("")
                  .toUpperCase();
    }
}

angular.module("nucont.shared")
    .service("UserProfileSidenavService", [UserProfileSidenavService]);
